export function notEmpty<V>(val: V | null | undefined): val is V {
  return val !== null && val !== undefined;
}

export function returnVoid(): void {
  return;
}

export function unique<V>(val: V[]): V[] {
  const idCheckMap = new Map();
  return val.reduce((prev: V[], curr) => {
    if (!curr || idCheckMap.has(curr)) {
      return prev;
    }

    idCheckMap.set(curr, true);

    return [...prev, curr];
  }, []);
}

export function createLookupTable<K extends keyof V, V extends { [Key in K]: string }>(
  val: V[],
  idKey: K
): Record<string, V> {
  return val.reduce((prev, curr) => {
    const entries: Record<string, V> = { ...prev };
    entries[curr[idKey]] = curr;
    return entries;
  }, {} as Record<string, V>);
}
